import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { AppThunk, RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus, ModalStatus } from "../common/enums";
import { MODAL_DELAY_MS } from "../../utils/constants";





export interface IGamification {
  login: number;
  finishLesson: number;
  finishTopic: number;
  finishCourse: number;
  certification: number;
  finishTest: number;
  finishExam: number;
  finishSurvey: number;
  activityBadges: boolean;
  learningBadges: boolean;
  opinionBadges: boolean;
  knowledgeBadges: boolean;
}

interface GamificationState {
  status: FetchStatus,
  data: IGamification | null;
  modalStatus: ModalStatus;
}

const initialState: GamificationState = {
  status: FetchStatus.Idle,
  data: null,
  modalStatus: ModalStatus.Hide,
};

interface GamificationFetch {
  login: number;
  finishLesson: number;
  finishTopic: number;
  finishCourse: number;
  certification: number;
  finishTest: number;
  finishExam: number;
  finishSurvey: number;
  activityBadges: boolean;
  learningBadges: boolean;
  opinionBadges: boolean;
  knowledgeBadges: boolean;
}

export const gamificationSlice = createSlice({
  name: "gamification",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<GamificationFetch>) => {
      state.status = FetchStatus.Fetched;
      state.data = action.payload;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
    showModal: (state) => {
      state.modalStatus = ModalStatus.Show;
    },
    hideModal: (state) => {
      state.modalStatus = ModalStatus.Hide;
    }
  },
});

const BASE_ENDPOINT = "/gamification";
// export const { fetch } = gamificationSlice.actions;
const { fetching, error, fetched, showModal } = gamificationSlice.actions;
export const {  hideModal } = gamificationSlice.actions;

const hideModalWithDelay = (): AppThunk => async (dispatch) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      dispatch(hideModal());
      resolve();
    }, MODAL_DELAY_MS);
  });
};

export const fetchGamification = (companyId: string) => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: `${BASE_ENDPOINT}/${companyId}`,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.COMPANY_SERVICE,
      authenticated: true,
    })
  );
};

export const saveGamification = (companyId: string, gamification: IGamification) => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: `${BASE_ENDPOINT}/${companyId}`,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
          {
            actionOrCreator: showModal,
            selector: () => {
              dispatch(hideModalWithDelay());
            },
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.PUT,
      microservice: Microservices.COMPANY_SERVICE,
      authenticated: true,
      data: gamification,
    })
  );
};

export const markMessageAsSeen =  () => (
  dispatch: Dispatch<object>
) => {
  return dispatch(
    apiActionCreator({
      endpoint: '/points/sawMessage',
      types: {
        requestType: { type: 'DO_NOTHING', payload: undefined },
        successTypes: [
          {
            actionOrCreator: { type: 'DO_NOTHING', payload: undefined },
          },
        ],
        errorTypes: [
          {
            actionOrCreator: { type: 'DO_NOTHING', payload: undefined },
          },
        ],
      },
      method: HttpMethods.POST,
      microservice: Microservices.COMPANY_SERVICE,
      authenticated: true,
    })
  );
};

export const selectGamificationIsFetching = (state: RootState) =>
  state.gamification.status === FetchStatus.Fetching;
export const selectGamification = (state: RootState) => state.gamification.data;

export const selectDisplayModal = (state: RootState) =>
  state.gamification.modalStatus === ModalStatus.Show;

export default gamificationSlice.reducer;
